import { connect, MapStateToProps } from "react-redux";

import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { ExistingActivitiesDialogComponent, ExistingActivitiesDialogComponentProps } from "../ExistingActivitiesDialogComponent";

export type ExistingActivitiesDialogProps = {
    readonly addTextLocKey: string;
};

type StateProps = Pick<ExistingActivitiesDialogComponentProps, "addText">;

const mapStateToProps: MapStateToProps<StateProps, ExistingActivitiesDialogProps, IAppState> = (state, { addTextLocKey }) => ({
    addText: getPrimaryText(state, addTextLocKey) ?? "",
});

export const ExistingActivitiesDialog = connect(mapStateToProps)(ExistingActivitiesDialogComponent);
